import Header from './scripts/Header'
import Footer from './scripts/Footer'
import Events from './scripts/Events'

function EventsPage() {

  return (
    <div id="#top" className="[ App ] [ flow:wide ]">
      <Header />
      <Events />
      <Footer />
    </div>
  )
}


export default EventsPage;